<div class="ip-success-snack-bar">
  <div class="ip-success-snack-bar__label" matSnackBarLabel>
    <h2>{{ this.data.title ?? '¡Hecho!' }}</h2>
    <p>{{ this.data.description }}</p>
  </div>
</div>
